import React from 'react';
import { Link } from 'react-router-dom';
import { CommentsShape, UserShape, PeopleSearchShape } from '../../shapes';
import Waiting from '../waiting';
import Comment from './comment';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import pluralize from 'pluralize';
import './styles.scss';

export default class Comments extends React.Component {

  static propTypes = {
    user: UserShape,
    peopleSearchObject: PeopleSearchShape,
    wordText: PropTypes.string,
    commentsContainer: CommentsShape,
    onResetComments: PropTypes.func,
    onLoadComments: PropTypes.func,
    onSaveComment: PropTypes.func,
    onDeleteComment: PropTypes.func,
    onSearchForPeople: PropTypes.func,
    onLikeComment: PropTypes.func,
    onUnLikeComment: PropTypes.func
  }

  state = {
    addComment: false
  }

  componentDidMount() {
    this.props.onResetComments();
    this.props.onLoadComments(this.props.wordText);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.addComment && this.state.addComment) {
      if (prevProps.commentsContainer.get('comments') !== this.props.commentsContainer.get('comments')) {
        this.setState({ addComment: false });
      }
    }
  }

  render() {
    if (this.props.commentsContainer.get('loading')) {
      return this.renderLoading();
    } else {
      return(
        <div className='comments'>
          { this.renderComments() }
        </div>
      );
    }
  }

  renderLoading() {
    return(
      <Waiting />
    )
  }

  renderComments() {
    const comments = this.props.commentsContainer.get('comments').map((comment) => {
      return (
        <li key={ comment.get('slug') } className='list-group-item'>
          <Comment
            writeable={ false }
            user={ this.props.user }
            comment={ comment }
            onSaveComment={ this.props.onSaveComment }
            onDeleteComment={  this.props.onDeleteComment }
            onLikeComment={ this.props.onLikeComment }
            onUnLikeComment={ this.props.onUnLikeComment }
          />
        </li>
      );
    });
    return (
      <div>
        <div className='discussion-header'>
          <h4>Discussion</h4>
          { this.renderDiscussionHeaderCTA() }
        </div>
        <ul className='list-group'>
          { this.renderWriteableCommentListItem() }
          { comments }
        </ul>
      </div>
    );
  }

  onSaveNewComment(slug, content, wordText) {
    this.props.onSaveComment(slug, content, wordText)
  }

  onCancelNewComment() {
    this.setState({ addComment: false });
  }

  onAddToDiscussion(event) {
    event.preventDefault();
    this.setState({ addComment: true });
  }

  renderDiscussionHeaderCTA() {
    if (this.props.user.get('loggedIn')) {
      return (
        <p className='item-meta'>
          { pluralize('comment', this.props.commentsContainer.get('comments').size, true) }
          <span className='header-meta-spacer'></span>
          <Link to='#' className='add-comment-cta' onClick={ event => this.onAddToDiscussion(event) }>Add a comment</Link>
        </p>
      )
    } else return (
      <p className='item-meta'>
        { pluralize('comment', this.props.commentsContainer.get('comments').size, true) }
      </p>
    )
  }

  renderWriteableCommentListItem() {
    if (this.state.addComment) {
      return (
        <li key={ 0 } className='list-group-item'>
          <Comment
            writeable={ true }
            user={ this.props.user }
            comment={ Immutable.fromJS({ wordText: this.props.wordText }) }
            onSaveComment={ this.onSaveNewComment.bind(this) }
            onDeleteComment={ this.props.onDeleteComment }
            onCancelNewComment={ this.onCancelNewComment.bind(this) }
            onSearchForPeople={ this.props.onSearchForPeople }
            peopleSearchObject={ this.props.peopleSearchObject }
          />
        </li>
      )
    } else return null;
  }
}



// WEBPACK FOOTER //
// ./src/components/comments/index.jsx